export { default } from '/components/form/phone-input/phone-input-view'
